import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import AppRouter from './components/Router/AppRouter';
import AppLoading from './components/Loading/AppLoading';
import ErrorBoundary from 'creatella-react-components/lib/ErrorBoundary';
import Helmet from 'creatella-react-components/lib/Helmet';
import GoogleTagManager from 'react-gtm-module';
import Alerts, { ALERTS_POSITION } from 'creatella-react-components/lib/Alerts';
import { handleAutoLogin } from 'redux/reducers/auth';
import HELMET_DEFAULT_CONFIG from 'config/executors/i18n-resources/helmet';
import {
    APP_LANGUAGE_DEFAULT, GTM_KEY, ROUTES,
    ROUTES_WITH_PUBLIC, ROUTE_MATCH_REPLACER
} from 'config/constants';
import './AppContainer.scss';
import PublicHeader from 'components/PublicHeader';
import PublicFooter from 'components/PublicFooter';

class AppContainer extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        autoLogin: PropTypes.func.isRequired,
        isAppReady: PropTypes.bool.isRequired,
        isAuthed: PropTypes.bool.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func.isRequired
        }).isRequired
    }

    componentDidMount() {
        const { autoLogin } = this.props;

        autoLogin();

        if (GTM_KEY) {
            GoogleTagManager.initialize({
                gtmId: GTM_KEY
            });
        }
    }

    shouldComponentUpdate(nextProps) {
        const { location, isAppReady, isAuthed } = this.props;
        const { pathname } = location;

        if (pathname !== nextProps.location.pathname ||
            isAppReady !== nextProps.isAppReady ||
            isAuthed !== nextProps.isAuthed) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isAuthed === true && this.props.isAuthed === false) { this.props.history.push(ROUTES.LOGIN); }
    }

    onError = (error, info) => {
        Sentry.withScope((scope) => {
            scope.setExtras('Info', info);
            Sentry.captureException(error);
        });
    }

    findRoute = route => {
        const { location: { pathname } } = this.props;
        const routeMatchReplacerIndex = route.indexOf(ROUTE_MATCH_REPLACER);

        if (routeMatchReplacerIndex > -1) {
            const routeChunk = route.slice(0, routeMatchReplacerIndex);
            const pathChunk = pathname.slice(routeMatchReplacerIndex);

            return `${routeChunk}${pathChunk}` === pathname;
        }

        if (route === pathname) {
            return route === pathname;
        }

        if (pathname === '/') {
            return true;
        }

        if (route + '/' === pathname) {
            return true;
        }

        // if (pathname === '/product' && route === '/product') {
        //     return true;
        // }
    }

    render() {
        const { isAppReady, location, history } = this.props;
        const { pathname } = location;
        const publicLayout = ROUTES_WITH_PUBLIC.findIndex(e => this.findRoute(e)) > -1;

        if (isAppReady) {
            return (
                <main className='AppContainer'>
                    {publicLayout &&
                        <PublicHeader history={history} />
                    }
                    <ErrorBoundary
                        pathname={pathname}
                        onError={this.onError}>
                        <AppRouter />
                    </ErrorBoundary>

                    <Helmet
                        pathname={pathname}
                        defaultConfig={HELMET_DEFAULT_CONFIG[APP_LANGUAGE_DEFAULT]} />

                    <Alerts
                        position={ALERTS_POSITION.BOTTOM_LEFT} />

                    {publicLayout &&
                        <PublicFooter />
                    }
                </main>
            );
        }

        return (
            <main className='AppContainer'>
                <Helmet
                    pathname={pathname}
                    defaultConfig={HELMET_DEFAULT_CONFIG[APP_LANGUAGE_DEFAULT]} />

                <AppLoading />
            </main>
        );
    }
}

const mapStateToProps = ({ auth, i18n }) => {
    const { isAppReady, isAuthed } = auth;

    return {
        isAppReady,
        isAuthed
    };
};

const mapDispatchToProps = (dispatch) => ({
    autoLogin: (location) => {
        dispatch(handleAutoLogin(location));
    }
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AppContainer)
);
